import React from 'react';
import StudentsLAB from '../persons/StudentsLAB';

const PersonsLAB = ({ id }) => {
    return <StudentsLAB id={id} />;
};

export default PersonsLAB;
